import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../../api/apiFactory";
import { showNotification } from "../notificationSlice";
const itemApi = factory.get("item");

const initialState = {
  items: {
    data: [],
    loading: false,
    total: 0,
    filters: {
      skip: 0,
      page: 0,
      take: 25,
      bar_code: "",
    },
  },
  item: {
    dialog: false,
    loading: false,
    form: {
      id: "",
      name: "",
      unite: "",
      price: 0,
      description: "",
      bar_code: "",
      required_serial: false,
    },
    errors: {},
  },
};

const itemSlice = createSlice({
  name: "item",
  initialState,
  reducers: {
    setItems: (state, { payload }) => {
      state.items.data = payload.data;
      state.items.total = payload.total;
    },
    setLoading: (state, { payload }) => {
      state[payload].loading = !state[payload].loading;
    },
    setFilters: (state, { payload }) => {
      state.items.filters = {
        ...state.items.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.items.filters = initialState.items.filters;
    },
    setItemDialog: (state, { payload }) => {
      state.item.form = {
        id: payload?.id || "",
        name: payload?.name || "",
        unite: payload?.unite || "",
        price: payload?.price || 0,
        description: payload?.description || "",
        bar_code: payload?.bar_code || "",
        required_serial: payload?.required_serial || false,
      };
      state.item.dialog = !state.item.dialog;
    },
  },
});

export const { setItems, setLoading, setFilters, resetFilters, setItemDialog } =
  itemSlice.actions;

export default itemSlice.reducer;

const index = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading("items"));
    const filters = getState().item.items.filters;
    const res = await itemApi.index(filters);
    dispatch(setItems(res.data));
    dispatch(setLoading("items"));
  } catch (err) {
    dispatch(setLoading("items"));
    throw new Error(err);
  }
};

const getById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading("item"));
    const res = await itemApi.show(id);
    dispatch(setItemDialog(res.data));
    dispatch(setLoading("item"));
  } catch (err) {
    dispatch(setLoading("item"));
    throw new Error(err);
  }
};

const create = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("item"));
    await itemApi.create(data);
    dispatch(setLoading("item"));
    dispatch(
      showNotification({
        message: "تم إضافة المادة بنجاح",
        type: "success",
      }),
    );
    dispatch(setItemDialog());
    dispatch(index());
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      }),
    );
    dispatch(setLoading("item"));
    throw new Error(err);
  }
};

const update = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("item"));
    await itemApi.update(data);
    dispatch(setLoading("item"));
    dispatch(
      showNotification({
        message: "تم تعديل المادة بنجاح",
        type: "success",
      }),
    );
    dispatch(setItemDialog());
    dispatch(index());
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      }),
    );
    dispatch(setLoading("item"));
    throw new Error(err);
  }
};

const deleteItem = (id) => async (dispatch) => {
  try {
    dispatch(setLoading("items"));
    await itemApi.delete(id);
    dispatch(
      showNotification({
        message: "تم الحذف بنجاح",
        type: "success",
      }),
    );
    dispatch(setLoading("items"));
    return true;
  } catch (err) {
    dispatch(setLoading("items"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      }),
    );
    throw new Error(err);
  }
};

export const Items = {
  index,
  getById,
  create,
  update,
  deleteItem,
};
